import { forwardRef } from "react";
import { Input } from "./ui/input";
import { formatCLP, parseCLP } from "../lib/format";

/**
 * Input que muestra el valor formateado en CLP ($68.000.000) y notifica
 * un Number al padre vía onChange.
 *
 * Props:
 *   - value:  Number (e.g. 68000000)
 *   - onChange: (n: number) => void
 *   - everything else forwarded to <Input>
 */
const MoneyInput = forwardRef(({ value, onChange, ...rest }, ref) => {
  const display = value === 0 || value ? formatCLP(value) : "";
  return (
    <Input
      ref={ref}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={display}
      onChange={(e) => onChange(parseCLP(e.target.value))}
      {...rest}
    />
  );
});

export default MoneyInput;
